class ControlValidation extends HTMLElement {
  constructor() {
    super();
    this.checkInputValidity = this.checkInputValidity.bind(this);
  }

  connectedCallback() {
    this.input = this.querySelector('input');
    this.errorElement = this.querySelector(`#${this.input.id}_error`);
    this.formElement = this.input?.form || this.closest('form');

    if (!this.input || !this.errorElement) return;

    this.input.addEventListener('change', this.checkInputValidity);
    this.input.addEventListener('blur', this.checkInputValidity);
    this.input.addEventListener('invalid', (e) => {
      e.preventDefault();
    });

    this.formElement?.addEventListener('submit', (e) => {
      this.checkInputValidity(e);
    });
  }

  disconnectedCallback() {
    this.input.removeEventListener('change', this.checkInputValidity);
    this.input.removeEventListener('blur', this.checkInputValidity);
    this.formElement?.removeEventListener('submit', this.checkInputValidity);
  }

  getValidationMessages() {
    if (!this.validationMessages) {
      this.validationMessages = {};
      const jsonElement = this.querySelector('[type="application/json"]');

      if (jsonElement && jsonElement.textContent) {
        try {
          this.validationMessages = JSON.parse(jsonElement.textContent);
        } catch (error) {
          console.error('Failed to parse validation messages', error);
          this.validationMessages = {};
        }
      }
    }

    return this.validationMessages;
  }

  setError(message) {
    if (!this.errorElement) return;

    this.errorElement.textContent = message;
    this.errorElement.removeAttribute('hidden');
    this.input.setAttribute('aria-invalid', true);
    this.input.setAttribute('aria-describedby', `${this.input.id}_error`);
  }

  hideError() {
    if (!this.errorElement) return;

    this.errorElement.textContent = '';
    this.errorElement.setAttribute('hidden', true);
    this.input.setAttribute('aria-invalid', false);
    this.input.removeAttribute('aria-describedby');
  }

  getErrorMessage() {
    const messages = this.getValidationMessages();
    const validity = this.input.validity;
    let message = this.input.validationMessage;

    for (let key in validity) {
      if (validity[key] === true && messages[key]) {
        message = messages[key];
        break;
      }
    }

    return message;
  }

  checkInputValidity() {
    if (!this.input.checkValidity()) {
      this.setError(this.getErrorMessage());
    } else {
      this.hideError();
    }

    this.input.addEventListener('input', this.checkInputValidity, { once: true });
  }
}

if (!customElements.get('control-validation')) {
  customElements.define('control-validation', ControlValidation);
}
